import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ClubProvider } from './context/ClubContext';
import { UIProvider } from './context/UIContext';
import { App } from './App.jsx';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ClubProvider>
          <UIProvider>
            <App />
          </UIProvider>
        </ClubProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
